const SUBSCRIPTION_CURRENCIES = ['USD', 'CAD'];

function normalizeCurrency(currency) {
  return typeof currency === 'string'
    ? currency.trim().toUpperCase()
    : undefined;
}

export { SUBSCRIPTION_CURRENCIES };

export const DEFAULT_SUBSCRIPTION_CURRENCY = SUBSCRIPTION_CURRENCIES[0];

export function getSupportedSubscriptionCurrency(currency) {
  const normalized = normalizeCurrency(currency);
  if (!normalized) return null;
  return SUBSCRIPTION_CURRENCIES.includes(normalized) ? normalized : null;
}
